// Static definition of the LONGEV CIRCLE Six Pillars + default MVP activities.
// Completion state is persisted server-side via /api/client-me/plan-completions.

import {
  Apple,
  Dumbbell,
  Activity,
  Stethoscope,
  Sparkles,
  Scissors,
} from "lucide-react";

export const PILLARS = [
  {
    id: "nutrition",
    name: "Nutrition Counselling",
    icon: Apple,
    tint: "bg-amber-50 text-amber-900 border-amber-200",
    activities: [
      { id: "nutrition.hydration", name: "Hit your daily hydration target", frequency: "Daily" },
      { id: "nutrition.foodlog",   name: "Log today's meals",               frequency: "Daily" },
      { id: "nutrition.protein",   name: "Protein with every meal",         frequency: "Daily" },
    ],
  },
  {
    id: "strength",
    name: "Strength & Mobility",
    icon: Dumbbell,
    tint: "bg-stone-100 text-stone-900 border-stone-200",
    activities: [
      { id: "strength.workout",  name: "Strength session",            frequency: "3× / week" },
      { id: "strength.mobility", name: "10-min mobility flow",        frequency: "Daily" },
      { id: "strength.grip",     name: "Weekly grip strength check",  frequency: "Weekly" },
    ],
  },
  {
    id: "endurance",
    name: "Endurance",
    icon: Activity,
    tint: "bg-emerald-50 text-emerald-900 border-emerald-200",
    activities: [
      { id: "endurance.steps",     name: "Reach your step target",      frequency: "Daily" },
      { id: "endurance.zone2",     name: "Zone-2 cardio session",       frequency: "2× / week" },
      { id: "endurance.intervals", name: "Interval / VO₂ session",      frequency: "Weekly" },
    ],
  },
  {
    id: "medical",
    name: "Medical Counselling",
    icon: Stethoscope,
    tint: "bg-sky-50 text-sky-900 border-sky-200",
    activities: [
      { id: "medical.vitals", name: "Log resting HR + BP",         frequency: "Weekly" },
      { id: "medical.labs",   name: "Review latest lab results",   frequency: "Monthly" },
      { id: "medical.checkin", name: "Doctor check-in",            frequency: "Quarterly" },
    ],
  },
  {
    id: "wellness",
    name: "Wellness",
    icon: Sparkles,
    tint: "bg-rose-50 text-rose-900 border-rose-200",
    activities: [
      { id: "wellness.sleep",     name: "7+ hours sleep",         frequency: "Daily" },
      { id: "wellness.breathwork", name: "Breathwork or meditation", frequency: "Daily" },
      { id: "wellness.sauna",     name: "Sauna session",          frequency: "Weekly" },
    ],
  },
  {
    id: "grooming",
    name: "Longevity & Grooming",
    icon: Scissors,
    tint: "bg-indigo-50 text-indigo-900 border-indigo-200",
    activities: [
      { id: "grooming.skincare", name: "AM / PM skincare",         frequency: "Daily" },
      { id: "grooming.posture",  name: "Posture reset breaks",     frequency: "Daily" },
      { id: "grooming.ritual",   name: "Monthly grooming ritual",  frequency: "Monthly" },
    ],
  },
];

export function findPillar(pillarId) {
  return PILLARS.find((p) => p.id === pillarId);
}
